import { dropdownEllipsisWidth } from "ds/components/DropdownMenu/constants";
import { Spacing } from "types/Spacing";
import { getDocsUrl } from "utils/getDocsUrl";

export const ITEMS_LIMIT = 50;

export const COLUMN_ORDER = `minmax(160px, 4.5fr) ${dropdownEllipsisWidth}`;
export const COLUMN_GAP: Spacing = "large";

export const VCS_INTEGRATIONS_DOCUMENTATION_LINK = getDocsUrl("/integrations/source-control");

export const GITHUB_INTEGRATION_DETAILS_DRAWER_ID = "github-integration-details-drawer";
export const BUILT_IN_GITHUB_INTEGRATION_NAME = "GitHub built-in integration";
export const BUILT_IN_GITHUB_INTEGRATION_DESCRIPTION =
  "This account was created from a GitHub account/organization, which is available for Stacks or Modules to use.";

export const ORIGIN_INTEGRATION_DETAILS_DRAWER_ID = "origin-integration-details-drawer";
export const ORIGIN_INTEGRATION_NAME = "Origin integration";
export const ORIGIN_INTEGRATION_DESCRIPTION =
  "Built-in integration with Cursor Origin, available for Stacks or Modules to use.";
